import { css } from '@emotion/react';
import { BadgeKind, BadgeColor, BadgeSize } from './types';
import { semantic_colors, text_styles, shapes } from '../../foundation';

export const badge_base_css = css`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  white-space: nowrap;
`;

export const badge_icon_size_css: Record<BadgeSize, number> = {
  small: 8,
  medium: 10,
  large: 12,
};

export const badge_color_css: Record<BadgeColor, string> = {
  pink: semantic_colors.brand.primary,
  blue: semantic_colors.accent.primary,
  gray: semantic_colors.content.secondary,
  red: semantic_colors.state.negative,
  green: semantic_colors.state.positive,
  orange: semantic_colors.state.warning,
};

const badge_background_color_css: Record<BadgeColor, string> = {
  pink: semantic_colors.brand.light,
  blue: semantic_colors.accent.light,
  gray: semantic_colors.fill.secondary,
  red: semantic_colors.state.negative_light,
  green: semantic_colors.state.positive_light,
  orange: semantic_colors.state.warning_light,
};

export const badge_size_css: Record<BadgeSize, string> = {
  small: `
    padding: 1px 6px;
    column-gap: 2px;
    ${shapes.border_radius.xlarge}
    ${text_styles.Caption_10_Medium};
  `,
  medium: `
    padding: 4px 8px;
    border-radius: 40px;
    column-gap: 2px;
    ${text_styles.Caption_11_Medium};
  `,
  large: `
    padding: 6px 12px;
    border-radius: 40px;
    column-gap: 4px;
    ${text_styles.Body_12_Medium};
  `,
};

export const rectangle_badge_size_css: Record<BadgeSize, string> = {
  small: `
    padding: 1px 4px;
    ${shapes.border_radius.xsmall};
  `,
  medium: `
    padding: 4px 6px;
    ${shapes.border_radius.xsmall};
  `,
  large: `
    padding: 6px 8px;
    ${shapes.border_radius.xsmall};
  `,
};

export const getBadgeStyleByProps = (kind: BadgeKind, color: BadgeColor) => {
  switch (kind) {
    case 'fill':
      return css`
        color: ${badge_color_css[color]};
        background-color: ${badge_background_color_css[color]};
      `;
    case 'outline':
    default:
      return css`
        color: ${badge_color_css[color]};
        box-shadow: ${badge_color_css[color]} 0px 0px 0px 1px inset;
      `;
  }
};
